<template>
	<div>
		<OverviewTitleBox :title="'CUSTOMER'" class="mb-3"/>
		<div class="" v-if="false">
			<H6 class="title-section">CUSTOMER</H6>
		</div>
		<div class="row mb-4">
			<div class="col-md-4">
				<InfoCard info="COMPLAINT 135" :value="complaint.p135" unit="On Progress"
					:url="'/customer/complaint?tab=0&status=On Progress'"/>
			</div>
			<div class="col-md-4">
				<InfoCard info="COMPLAINT SPBU" :value="complaint.spbu" unit="On Progress"
					:url="'/customer/complaint?tab=1&status=On Progress'"/>
			</div>
		</div>
	</div>
</template>

<script>
import Customer from '@/components/page/Customer.js'
import InfoCard from '@/views/pages/InfoCard.vue'
import OverviewTitleBox from '@/views/component/OverviewTitleBox.vue'

export default{
	extends: Customer,
	components:{
		InfoCard,
		OverviewTitleBox,
	},
    mounted(){
		this.loadComplaint();
    },
    methods:{
	}
}

</script>